import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=42af7385&"
import script from "./CourseOverview.vue?vue&type=script&lang=js&"
export * from "./CourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports